<h1>Vragen over LETS</h1>

<p>Ruilen met LETS biedt nieuwe mogelijkheden.</p>

<p>Kan je iets waarmee je anderen kan helpen?</p>
<p>Heb je zelf soms hulp nodig of mis je een stuk gereedschap dat je eens wil gebruiken?</p>
<p>Leer je graag mensen kennen in de buurt?</p>
<p>Dan is LETS iets voor jou.</p>

<div class="vraag">
	<span class="kop">Wat?</span>
	<span class="antwoord"
		>LETS = Lokaal Economisch Transactie Systeem of eenvoudiger: lokale ruilkring. Het hoofddoel is
		&apos;iets doen voor een ander&apos;, wij noemen dat diensten ruilen &ndash; alhoewel je niets
		direct terug moet doen &hellip; je krijgt &apos;punten&apos; voor je werk, die punten kan je dan
		zelf gebruiken. (20 punten (= IETSEN) per uur)
	</span>
</div>

<div class="vraag">
	<span class="kop">Wie?</span>
	<span class="antwoord">
		Iedereen die wil aansluiten kan LETSer worden, want iedereen kan iets. We vinden elkaar via een beveiligde site waar we de leden hun contactgegevens, hun vraag en hun aanbod kunnen zien.
	</span>
</div>

<div class="vraag">
	<span class="kop">Wat?</span>
	<span class="antwoord">
		Wat kan je niet goed of doe je niet graag? Waarvoor heb je momenteel tijd tekort? Waarmee kan iemand jou helpen? (Want samen gaat het ook sneller en is het vaak leuker.)
	</span>
</div>

<div class="vraag">
	<span class="kop">Aanbod?</span>
	<span class="antwoord">
		Wat doe je graag of kan je goed? Waarmee wil je een ander helpen? Wat kan jij 'maken' voor anderen? Je kan meer dan je denkt ;-) Welke waardevolle goederen wil je een 2e leven geven? 
	</span>
</div>

<div class="vraag">
	<span class="kop">Goederen?</span>
	<span class="antwoord">
		Je kan ook goederen 'verLETSen' (niet verkopen voor euro's). Het moeilijkste is dan om de waarde te bepalen … Denk: ik wil er een uur voor werken dus is het mij 20 ietsen waard … Of je gebruikt de omrekening: 1 uur = 20 ietsen = 20 euro. Het belangrijkste is dat je beiden een goed gevoel hebt bij de gekozen waarde.
	</span>
</div>

<div class="vraag">
	<span class="kop">Waarom?</span>
	<span class="antwoord">
		Vanuit een sociale, alternatief economische of ecologische invalshoek.
	</span>
</div>

<div class="vraag">
	<span class="kop">Sociaal?</span>
	<span class="antwoord">
		We helpen en worden geholpen, leren anderen kennen en waarderen.
	</span>
</div>

<div class="vraag">
	<span class="kop">Economisch?</span>
	<span class="antwoord">
		We 'betalen' elkaar niet met euro's, maar met een soort punten, in onze LETSgroep noemen we ze 'ietsen'. (Echte kosten bv. ingrediënten en vervoerskosten mogen wel in euro.)
	</span>
</div>

<div class="vraag">
	<span class="kop">Duurzaam?</span>
	<span class="antwoord">
		We kunnen spullen verLETSen en dus een 2e leven geven, we kunnen materiaal lenen, we kunnen dingen (laten) herstellen.
	</span>
</div>

<div class="vraag">
	<span class="kop">Hoe?</span>
	<span class="antwoord">
		Via onze beveiligde LETSsite weten we wat een ander vraagt en aanbiedt, en kunnen we zelf iets vragen en aanbieden. Dan kunnen we contact opnemen en afspreken.
	</span>
</div>

<div class="vraag">
	<span class="kop">Waar?</span>
	<span class="antwoord">
		Wij zijn een deel van de grote groep LETS Aalst-Oudenaarde en kunnen dus zonder problemen met al onze leden in deze grote regio. (En zelfs interLETSen met andere LETSgroepen.)
	</span>
</div>


<div class="vraag">
	<span class="kop">Hoeveel?</span>
	<span class="antwoord">
		Dat kies je volledig zelf. In LETS móét je niets (behalve een aantal 'spelregels' volgen, voor de goede gang van zaken ;-) Dat gaat dus van eens per jaar tot meerdere keren per week.
	</span>
</div>

<div class="vraag">
	<span class="kop">Voordeel?</span>
	<span class="antwoord">
		Het is geen echt geld, dat maakt mensen makkelijker, vrijgeviger. Je moet natuurlijk wel iets doen om 'ietsen' te verkrijgen.
	</span>
</div>

<div class="vraag">
	<span class="kop">Nog vragen?</span>
	<span class="antwoord">
		Contacteer <a href="/contact">ons</a>.
	</span>
</div>

<div class="vraag">
	<span class="kop">Lid worden?</span>
	<span class="antwoord">
		We hebben liefst dat je eerst een infosessie (meestal in Zottegem of Oudenaarde) – omdat we jou dan veel praktische info kunnen geven, onze LETSsite kunnen uitleggen &hellip; maar als dat nog niet lukt dan kan je wel al starten.
Heb je vragen of interesse, mail vrijblijvend naar LetsRegioZottegem@yahoo.com
(€15/jaar voor lidgeld+verzekering voor werkenden, aangepaste tarieven voor wie (tijdelijk) geen werk heeft. <br>
Je krijgt dan 100 ietsen om mee te starten, als dat geen mooi cadeau is ;-)
	</span>
</div>

<div class="vraag">
	<span class="kop">Meer lezen?</span>
	<span class="antwoord">
		<a href="./Lets_stripverhaal.pdf" target="_blank"
		>Lets - in 10 vragen eenvoudig uitgelegd in Wablieft</a>
	</span>
</div>
	

<style scoped>
	.vraag {
		display: flex;
		margin: 20px 0;
	}

	.kop {
		width: 120px;
	}

	.antwoord {
		width: 100%;
	}
</style>

